// src/pages/Career.js 
// (Assuming this file contains your Career component)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar';
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';

// Page Component
import CareerPageContent from './PageComponent/CareerPageContent';

function Career() {

  // The useMeta hook call is removed and its content is moved into <Helmet>
  return (
    <>
      <Helmet>
        {/* Primary SEO Tags */}
        <title>Careers with Marvel Blinds - Apply for a Job - Discover a New World Of Career Opportunities</title>
        <meta
          name="description"
          content="Dynamic careers await at Marvel Lifestyle! Review available positions and take the first step towards a fulfilling professional path today."
        />
        <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/career/`} />

        {/* Open Graph Tags (for Social Media) */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Careers with Marvel Blinds" />
        <meta
          property="og:description"
          content="Dynamic careers await at Marvel Lifestyle! Review available positions and take the first step towards a fulfilling professional path today."
        />
        <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/career/`} />
        <meta property="og:site_name" content="Marvel Blinds" />
      </Helmet>

      {/* Rest of your component structure */}
      <div>
        <Navbar />
        <NotificationBar />
        <CareerPageContent />
        <Footer />
      </div>
    </>
  );
}

export default Career;